// extracted by mini-css-extract-plugin
module.exports = {"Canvas":"Orbits3D_Canvas__1YN-d"};